export default __webpack_public_path__ + "static/Citrine-Logo-4fe2df3d9301a471b829facc41ea9e63.png";